// extracted by mini-css-extract-plugin
module.exports = {"overview":"overview_overview__EoRQY","description":"overview_description__1dMnf","allSolutions":"overview_allSolutions__1avbm","column":"overview_column__1kyeg"};